export const version = "ethers/5.2.0";
